import type { OwnerBannerOption, StoreResponse } from '@clarity/contract';
import type { useI18n } from '../../lib/i18n.js';
import { dayMonth, dec } from '../format.js';
import { dayMonthYear } from './bannerFormat.js';

/** The i18n translate function (`useI18n().t`), passed in so this stays pure. */
export type Translate = ReturnType<typeof useI18n>['t'];

/**
 * The Join_Message (clarity-banner-options Req 7.2): the pre-filled text an
 * owner sends their account manager. Names the platform, the option, where it
 * appears, the next run's dates and fee, and the branch name + external store
 * id. Pure: translation and locale come in as arguments.
 *
 * A branch without a captured name falls back to its external id, so the
 * message never carries an empty name.
 */
export function joinMessage(
  option: Pick<OwnerBannerOption, 'platformKey' | 'name' | 'where' | 'nextRun'>,
  store: Pick<StoreResponse, 'name' | 'externalStoreId'>,
  t: Translate,
  locale?: string,
): string {
  const run = option.nextRun;
  return t('banners.join.message', {
    platform: t(`bannerOptions.platform.${option.platformKey}`),
    name: option.name,
    where: option.where,
    from: dayMonth(run.from, locale),
    to: dayMonthYear(run.to, locale),
    fee: dec(run.fee, 2, locale),
    branch: store.name ?? store.externalStoreId,
    externalId: store.externalStoreId,
  });
}
